import { cart } from '../objects/cart'
// https://shopify.dev/docs/api/storefront/2023-10/queries/cart
export const retreiveCart = `
query ($cartId: ID!) {
  cart(id: $cartId) ${cart}
}`
